<div mat-dialog-title>
  <h2>
    {{"productEvaluationForm.fillEvaluationForm" | translate}}
  </h2>
  <button mat-icon-button class="close" aria-label="Close" [disabled]="loading" (click)="openConfirmDialog()">
    <mat-icon class="pop-close">close</mat-icon>
  </button>
</div>

<form [formGroup]="formGroup">
  <mat-dialog-content class="p-0">

    <div *ngIf="fetching" class="d-flex justify-content-center align-items-center py-5">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
    <div class="mat-dialog-body p-0" *ngIf="!fetching && items.controls.length">
      <div class="data_toolbar product_data">
        <div class="name-with-image-rounded">
          <div class="image-rounded">
            <div class="image">
              <img *ngIf="criteriaData.productImage" [src]="criteriaData.productImage"
                (error)='criteriaData.productImage  = "assets/images/no_logo.png"'>
              <span *ngIf="!criteriaData.productImage">
                {{ criteriaData.productName| shortName }}
              </span>
            </div>
          </div>
          <div class="name">
            <h5>{{criteriaData.productName}}</h5>
          </div>
        </div>
      </div>
      <div class="question_container">

        <div class="question_header">
          <div class="question_steps">
            <span class="question_num">
              {{ selectedIndex + 1 }}
            </span>
            {{"general.of" | translate}}
            {{ items.controls.length }}
          </div>
          <mat-progress-bar mode="determinate" [value]="((selectedIndex + 1) / items.controls.length) * 100"
            [color]="'warn'"></mat-progress-bar>
        </div>

        <div class="question_content">
          <mat-horizontal-stepper [linear]="true" #stepper [selectedIndex]="selectedIndex">

            <ng-container *ngFor="let item of items.controls; let i = index" formArrayName="items">
              <mat-step [stepControl]="item" [completed]="item.valid">
                <ng-container [formGroupName]="i">

                  <ng-container *ngIf="getQuestionDetails(item) as criteria">

                    <h4 class="question_title">
                      {{ criteria.name }}
                    </h4>

                    <p class="question_desc" *ngIf="criteria.isAttachmentsRequired">
                      {{"forms.requiresEvidenceAfterAnsweringQuestion" | translate}}
                    </p>

                    <!-- Numeric Input -->
                    <mat-form-field
                      *ngIf="criteria.technicalCriteriaAnswerTypeCode === criteriaAnswerTypeCode.Percentage"
                      class="w-100">
                      <mat-label>{{"general.response" | translate}}</mat-label>
                      <input matInput type="text" formControlName="answer" appPercentageDirective min="0" max="100" />
                      <span matSuffix>%</span>
                      <mat-error *ngIf="hasError('answer', 'required', i)">
                        {{"evaluationTasks.questionRequired" | translate}}
                      </mat-error>
                    </mat-form-field>

                    <!-- Numeric Input -->
                    <mat-form-field *ngIf="criteria.technicalCriteriaAnswerTypeCode === criteriaAnswerTypeCode.Numeric"
                      class="w-100">
                      <mat-label>{{"general.response" | translate}}</mat-label>
                      <input matInput type="text" formControlName="answer" appOnlyDecimal maxlength="10" />
                      <mat-error *ngIf="hasError('answer', 'required', i)">
                        {{"evaluationTasks.questionRequired" | translate}}
                      </mat-error>
                    </mat-form-field>

                    <!-- Percentage / Single Choice -->
                    <!-- <ng-container
                      *ngIf="criteria.technicalCriteriaAnswerTypeCode === criteriaAnswerTypeCode.Percentage">
                      <mat-radio-group formControlName="answer" class="row">
                        <div class="col-md-6 col-12 mb-3" *ngFor="let option of criteria.criteriaAnswers">
                          <mat-radio-button class="radio_has_bg" [value]="option.id">
                            {{ option.name || option.title }}
                          </mat-radio-button>
                        </div>
                      </mat-radio-group>
                      <mat-error *ngIf="hasError('answer', 'required', i)">
                        {{"evaluationTasks.questionRequired" | translate}}
                      </mat-error>
                    </ng-container> -->

                    <!-- Star Rating -->

                    @if(criteria.technicalCriteriaAnswerTypeCode === criteriaAnswerTypeCode.Star_Rating) {
                      <div class="star_rating text-align-center">
                        <mat-icon *ngFor="let star of [1,2,3,4,5]" class="star_icon"
                          [class.filled]="star <= (item.get('answer')?.value || 0)"
                          (click)="setStarValue(item, star)">
                          {{ star <= (item.get('answer')?.value || 0) ? 'star' : 'star_border' }} </mat-icon>
                      </div>
                      <mat-error *ngIf="hasError('answer', 'required', i)">
                        {{"evaluationTasks.questionRequired" | translate}}
                      </mat-error>
                    }

                    <!-- Clear Response Button -->
                    <div class="row"
                      *ngIf="item.get('answer')?.value && criteria.technicalCriteriaAnswerTypeCode === criteriaAnswerTypeCode.Star_Rating">
                      <div class="col-12 d-flex justify-content-end mb-2">
                        <button mat-raised-button type="button" (click)="clearResponce(item)"
                          class="mat-grey-F1">
                          {{"general.clearResponses" | translate}}
                        </button>
                      </div>
                    </div>

                    <!-- Attachments Section -->
                    <ng-container
                      *ngIf="item.get('answer')?.value || (item.get('files')?.value && item.get('files')?.value.length)">
                      <ng-container
                        *ngIf="criteria.isAttachmentsRequired || (criteria.attachmentUrls && criteria.attachmentUrls.length)">
                        <h5 class="question_sub_title">
                          {{"general.pleaseAttachEvidence" | translate}}
                        </h5>
                        <app-file-manager class="one-col" [files]="item.get('files')?.value"
                          [maxSize]="5"
                          [maxFiles]="5"
                          [isRequired]="hasError('files', 'required', i) || (item.get('files')?.value && item.get('files')?.value.length)"
                          [isSubmitted]="hasError('files', 'required', i)" [allowedExt]="['png', 'jpg', 'jpeg', 'pdf']"
                          [managerIndex]="i"
                          [invalidFileExtensions]="'evaluationTasks.fileFormatNotSupported'"
                          [required]="'evaluationTasks.evidenceRequired'"
                          (selectedFiles)="onFilesSelected(item, $event)" (deletedFilesList)="deleteFile(item, $event)">
                        </app-file-manager>
                      </ng-container>
                    </ng-container>

                  </ng-container>

                  <!-- Step Action Buttons -->
                  <div class="btn_actions">
                    <div>
                      <button mat-raised-button type="button" class="mat-grey-F1" matStepperPrevious
                        (click)="selectedIndex = (selectedIndex - 1)" *ngIf="i">
                        {{"general.back" | translate}}
                      </button>
                    </div>

                    <button mat-button type="button" color="primary" matStepperNext
                      *ngIf="i + 1 != items.controls.length" (click)="handelSteps(i)">
                      {{"general.next" | translate}}
                    </button>

                    <button mat-button color="primary" type="button" [class.loading]="loading" [disabled]="loading" (click)="saveRecord()"
                      *ngIf="i + 1 == items.controls.length">
                      {{"auth.confirm" | translate}}
                    </button>
                  </div>

                </ng-container>
              </mat-step>
            </ng-container>

          </mat-horizontal-stepper>
        </div>
      </div>
    </div>

  </mat-dialog-content>
</form>
